import Page from 'component/Page';
import { useEffect, useMemo, useState } from 'react';
import sendRequest, { sendPost } from 'util/request';
import * as fincode1 from 'util/requestFincode';
import string from 'util/string';
import Urls from 'util/urls';
import Table from 'component/Table';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'redux/user/user.selector';
import { ACCOUNT_ROLE_ADMIN } from 'util/permission';
import { useCallback } from 'react';
import { getParams } from 'util/utils';
import {
    nNU,
    showConfirm,
    showToast,
    formatMinutes
} from 'util/utils';
import { Button } from 'react-bootstrap';


const headers = [
    string.APP_SC_ASSIGN_CHANNEL_DISPLAY_NAME,
    string.APP_SC_ASSIGN_CHANNEL_GROUP_ID,
];

const PurchaseSecretChannel = ({ data = { id: null } }) => {
    //-------------------------------HOOKS-------------------------------------------------------------
    const params = getParams();
    const serviceCodeId = data.id || params?.id;

    const currentUser = useSelector(selectCurrentUser);
    const isAdmin = useMemo(
        () => currentUser.accountRole === ACCOUNT_ROLE_ADMIN,
        [ currentUser.accountRole ]
    );
    const isMonitorOnly = useMemo(
        () => currentUser.isMonitorOnly === 1,
        [ currentUser.isMonitorOnly ]
    );

    const [ page, setPage ] = useState(1);
    const [ total, setTotal ] = useState(0);
    const [ pageSize, setPageSize ] = useState(100);
    // const [ pageSize, setPageSize ] = useState(10);

    const [ searchId, setSearchId ] = useState('');
    const [ debouncedSearchId, setDebouncedSearchId ] = useState(searchId);

    const [ channels, setChannels ] = useState([]);
    const [ assignChannels, setAssignChannels ] = useState([]);
    const [ assignTotal, setAssignTotal ] = useState(0);

    const [ assign, setAssign ] = useState(null);
    const [ serviceCode, setServiceCode ] = useState(null);
    const [ assignableVolume, setAssignableVolume ] = useState(0);
    const [ selectedItem, setSelectedItem ] = useState([]);
    const [ selectedCheckboxCount, setSelectedCheckboxCount ] = useState(0);
    const [ price, setPrice ] = useState(800);
    const [ isAnyCheckboxSelected, setIsAnyCheckboxSelected ] = useState(false);

    //------------------------------FUNCTIONS----------------------------------------------------------
    useEffect(() => {
        if (!nNU(serviceCodeId)) {
            return;
        }
        sendRequest({
            url: `${Urls.servicecode.info}/${serviceCodeId}`,
            method: 'GET',
        }).then((response) => {
            const { result } = response;
            setServiceCode(result);
            let volume = result?.volume - result?.volumeUsage;
            setAssignableVolume(volume);
        }).catch((e) => {

        });
    }, [ serviceCodeId ]);

    const doSearch = useCallback(
        async (page, pageSize, searchKeyword, getAll = false) => {
            if (!nNU(currentUser.id)) {
                return;
            }
            let data = await sendPost({
                url: Urls.pocchannel.userlist,
                body: {
                    id: currentUser.id,
                    offset: (page - 1) * pageSize,
                    size: pageSize,
                    keyword: searchKeyword,
                },
            });
            const { total, result } = data;
            if (!getAll) {
                setChannels(result);
                setTotal(total);
            }
            return result;
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [ currentUser ]
    );

    useEffect(() => {
        const timerId = setTimeout(() => {
            setDebouncedSearchId(searchId);
        }, 500);

        return () => {
            clearTimeout(timerId);
        };
    }, [ searchId ]);

    useEffect(() => {
        doSearch(page, pageSize, debouncedSearchId);
    }, [ page, pageSize, debouncedSearchId, doSearch ]);

    const dataTable = useCallback(
        (data) => data.map((raw, key) => ({
            key: raw.groupId,
            data: [
                raw.groupName,
                raw.groupId.toString().padStart(4, '0'),

            ],
            raw,
        })),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [ assignTotal, assignChannels ]
    );
    const dataSubtable = useCallback(
        () => {
            let data = [];
            data.push({
                data: [
                    selectedCheckboxCount,
                    price,
                    selectedCheckboxCount * 800
                ]
            });
            // console.log(data)
            return data;

        },
        [ selectedCheckboxCount, price, isAnyCheckboxSelected ]

    );
    // console.log(selectedCheckboxCount)
    useEffect(() => {
        const newPrice = selectedCheckboxCount * 800;
        setPrice(newPrice);
    }, [ selectedCheckboxCount ]);

    // const mainActions = (assignableVolume > 0) ? [
    //     {
    //         icon: 'assign', title: string.APP_SC_ASSIGN_CHANNEL, onClick: () => {
    //             if (assignChannels.length > 0) {
    //                 setAssign(assignChannels);
    //             }
    //         }
    //     },
   const mainActions = [
        {        
			icon: 'pay',
			title: string.APP_PC_PREPAID_PAY,
			onClick: () => handlePayClick(),
		
        }

    ];

    const onSelect = (e) => {
        let { raw } = e;
        let arr;
        let idx = -1;
        selectedItem?.forEach((item, index) => {
            if (item.groupId === raw.groupId) {
                idx = index;
                return;
            }
        });
        if (idx > -1) {
            let { [ idx ]: itm, ...rest } = selectedItem;
            arr = Object.values(rest);
        } else {
            arr = [ ...selectedItem, raw ];
        }
        setSelectedItem(arr);
        setSelectedCheckboxCount(arr.length);
        setIsAnyCheckboxSelected(arr.length > 0);
    };
    const actions = (isMonitorOnly === false) ? [
        ({ raw }) => {
            if (raw.status !== 1) {
                return;
            }
            let idx = -1;
            selectedItem?.forEach((item, index) => {
                if (item.groupId === raw.groupId) {
                    idx = index;
                    return;
                }
            });
            return selectedItem.indexOf(raw.groupId) > -1
                ? null
                : {
                    render: idx > -1 ? 'selected' : 'select',
                    onClick: onSelect,
                };
        },
    ] : [];
    const handlePayClick = async () => {
        let data = {
            "pay_type": "Card",
            "plan_id": "pl_M_1m9Xq5Sp-qCyNJ6aAngA",
            "customer_id": "00021",
            "card_id": "5111111111111111",
            "start_date": "2024/03/20",
        };
        const response = await fincode1.sendPost({
            url: 'https://api.test.fincode.jp/v1/subscriptions',
            body: data,
        })
    };
    


    //-------------------------------RETURN------------------------------------------------------------
    return (
        <>
            <Page
                // title={`合計：${assignableVolume}、割当：${assignTotal}／残り：${assignableVolume - assignTotal}`}
                body={
                    <>
                        {/* <FormControls controls={formControls} /> */}
                        <Table
                            className="nowrap"
                            page={page}
                            pageSize={pageSize}
                            total={total}
                            onPageChanged={setPage}
                            onPageSizeChanged={setPageSize}
                            headers={headers}
                            data={dataTable(channels)}
                            // getCSVData={async () => {
                            // 		return dataTable(await doSearch(1, total, null, true));
                            // }}
                            // csvFileName="AppUserList"
                            isPaging={false}
                            mainActions={mainActions}
                            actions={actions}
                            search={false}
                        // onSearch={(value) => setSearchId(value)}
                        // placeHolder={`${string.POC_LOGIN_ID}、${string.POC_DISPLAY_NAME}`}
                        />
                        <div>{isAnyCheckboxSelected && (
                            <Table
                                isPaging={false}
                                headers={[
                                    'appid',
                                    'prices',
                                    'quantity',
                                ]}
                                data={dataSubtable()}
                            />
                        )}</div>
                        {/* <div className='function-button-area' style={{ marginTop: '15px' }}>
                            <Button className="btn" onClick={handlePayClick} >
                                PAY
                            </Button>
                        </div> */}
                    </>
                }
            />
        </>
    );
};

export default PurchaseSecretChannel;
